export const greeting = () => {
  const hour = new Date().getHours();

  if (hour >= 5 && hour < 12) {
    return 'dashboard.goodMorning';
  } else if (hour >= 12 && hour < 18) {
    return 'dashboard.goodAfternoon';
  } else {
    return 'dashboard.goodEvening';
  }
};

export const getApiErrorMessage = (error: any): string => {
  const data = error?.response?.data;

  if (typeof data === 'string') return data.trim();

  const message =
    data?.message ??
    data?.error?.message ??
    data?.error ??
    data?.detail ??
    (Array.isArray(data?.errors) ? data.errors[0]?.message : undefined);

  return typeof message === 'string' ? message.trim() : '';
};

export const isEmailAlreadyExistsError = (error: any): boolean => {
  if (error?.response?.status === 409) return true;

  return /already\s*(exists|registered|taken|in use)|duplicate|unique constraint|E11000/i.test(
    getApiErrorMessage(error),
  );
};

/**
 * Parses user-entered amounts that may use de-CH grouping (1'234.50) or U.S. thousands (1,234.50).
 * Plain `parseFloat` returns wrong values: parseFloat("8'000") === 8, parseFloat("8,000.00") === 8.
 */
export const parseAmountInput = (value: string | number | null | undefined): number => {
  if (value == null || value === '') return NaN;
  if (typeof value === 'number') {
    return Number.isFinite(value) ? value : NaN;
  }
  let s = String(value)
    .trim()
    .replace(/'/g, '') // de-CH thousands
    .replace(/\s/g, '');
  if (s === '') return NaN;
  if (s.includes('.')) {
    s = s.replace(/,/g, ''); // "1,234.56" → 1234.56
  } else if (/^\d+,\d{1,2}$/.test(s)) {
    s = s.replace(',', '.'); // "50,5" or "1,00" as decimal
  } else {
    s = s.replace(/,/g, ''); // "8,000" → 8000
  }
  return parseFloat(s);
};

export const formatSwissAmount = (amount: number | string) => {
  const parsed = typeof amount === 'string' ? parseAmountInput(amount) : amount;
  if (typeof parsed !== 'number' || isNaN(parsed)) return amount;
  return new Intl.NumberFormat('de-CH', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(parsed);
};

export const convertFileToBase64 = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = (error) => reject(error);
  });
};

export const countries = [
	{ labelKey: 'countries.afghanistan', value: 'AF', dialCode: '93' },
	{ labelKey: 'countries.austria', value: 'AT', dialCode: '43' },
	{ labelKey: 'countries.belgium', value: 'BE', dialCode: '32' },
	{ labelKey: 'countries.bosniaAndHerzegovina', value: 'BA', dialCode: '387' },
	{ labelKey: 'countries.brazil', value: 'BR', dialCode: '55' },
	{ labelKey: 'countries.bulgaria', value: 'BG', dialCode: '359' },
	{ labelKey: 'countries.croatia', value: 'HR', dialCode: '385' },
	{ labelKey: 'countries.cyprus', value: 'CY', dialCode: '357' },
	{ labelKey: 'countries.czechRepublic', value: 'CZ', dialCode: '420' },
	{ labelKey: 'countries.denmark', value: 'DK', dialCode: '45' },
	{ labelKey: 'countries.eritrea', value: 'ER', dialCode: '291' },
	{ labelKey: 'countries.estonia', value: 'EE', dialCode: '372' },
	{ labelKey: 'countries.finland', value: 'FI', dialCode: '358' },
	{ labelKey: 'countries.france', value: 'FR', dialCode: '33' },
	{ labelKey: 'countries.germany', value: 'DE', dialCode: '49' },
	{ labelKey: 'countries.greece', value: 'GR', dialCode: '30' },
	{ labelKey: 'countries.hungary', value: 'HU', dialCode: '36' },
	{ labelKey: 'countries.ireland', value: 'IE', dialCode: '353' },
	{ labelKey: 'countries.italy', value: 'IT', dialCode: '39' },
	{ labelKey: 'countries.kazakhstan', value: 'KZ', dialCode: '7' },
	{ labelKey: 'countries.kosovo', value: 'XK', dialCode: '383' },
	{ labelKey: 'countries.latvia', value: 'LV', dialCode: '371' },
	{ labelKey: 'countries.liechtenstein', value: 'LI', dialCode: '423' },
	{ labelKey: 'countries.lithuania', value: 'LT', dialCode: '370' },
	{ labelKey: 'countries.luxembourg', value: 'LU', dialCode: '352' },
	{ labelKey: 'countries.malta', value: 'MT', dialCode: '356' },
	{ labelKey: 'countries.netherlands', value: 'NL', dialCode: '31' },
	{ labelKey: 'countries.northMacedonia', value: 'MK', dialCode: '389' },
	{ labelKey: 'countries.poland', value: 'PL', dialCode: '48' },
	{ labelKey: 'countries.portugal', value: 'PT', dialCode: '351' },
	{ labelKey: 'countries.romania', value: 'RO', dialCode: '40' },
	{ labelKey: 'countries.slovakia', value: 'SK', dialCode: '421' },
	{ labelKey: 'countries.slovenia', value: 'SI', dialCode: '386' },
	{ labelKey: 'countries.spain', value: 'ES', dialCode: '34' },
	{ labelKey: 'countries.sweden', value: 'SE', dialCode: '46' },
	{ labelKey: 'countries.switzerland', value: 'CH', dialCode: '41' },
	{ labelKey: 'countries.unitedKingdom', value: 'GB', dialCode: '44' },
];

export const typeOfInvoiceOptions = [
  { labelKey: 'typeOfInvoiceOptions.hourly', value: 'Hourly' },
//   { labelKey: 'typeOfInvoiceOptions.daily', value: 'Daily' },
  { labelKey: 'typeOfInvoiceOptions.monthly', value: 'Monthly' },
  { labelKey: 'typeOfInvoiceOptions.flatRate', value: 'Flat Rate' },
];

export const languages = [
  { labelKey: 'languages.english', value: 'en' },
  { labelKey: 'languages.german', value: 'de' },
];

export const referralSourceOptions = [
  { labelKey: 'referralSourceOptions.google', value: 'google' },
  { labelKey: 'referralSourceOptions.linkedin', value: 'linkedin' },
  { labelKey: 'referralSourceOptions.recommendation', value: 'recommendation' },
  { labelKey: 'referralSourceOptions.other', value: 'other' },
];

export const workPermitOptions = [
  { labelKey: 'workPermitOptions.select', value: '' },
  { labelKey: 'workPermitOptions.permitB', value: 'Permit B EU/EFTA' },
  { labelKey: 'workPermitOptions.permitC', value: 'Permit C EU/EFTA' },
  { labelKey: 'workPermitOptions.permitCi', value: 'Permit Ci EU/EFTA' },
  { labelKey: 'workPermitOptions.permitG', value: 'Permit G EU/EFTA' },
  { labelKey: 'workPermitOptions.permitL', value: 'Permit L EU/EFTA' },
  {
    labelKey: 'workPermitOptions.notificationProcedure',
    value: 'Notification Procedure',
  },
];

const PHONE_SEPARATORS = /[\s\u00a0\-\u2011/.()']/g;
const E164_PATTERN = /^[1-9]\d{6,14}$/;
const MIN_NATIONAL_DIGITS = 4;

// Italy keeps the trunk zero inside the international number; every other country
// in the list drops it (079 123 45 67 -> +41791234567).
const TRUNK_ZERO_COUNTRIES = ['IT'];

export const DEFAULT_PHONE_COUNTRY = 'CH';

export const normalizePhoneNumber = (
  countryCode: string,
  value: string,
): string | null => {
  const cleaned = value.trim().replace(PHONE_SEPARATORS, '');

  if (/^(\+|00)/.test(cleaned)) {
    const digits = cleaned.replace(/^(\+|00)/, '');
    return E164_PATTERN.test(digits) ? `+${digits}` : null;
  }

  const country = countries.find((item) => item.value === countryCode);

  if (!country || !/^\d+$/.test(cleaned)) return null;

  const national = TRUNK_ZERO_COUNTRIES.includes(country.value)
    ? cleaned
    : cleaned.replace(/^0+/, '');

  if (national.length < MIN_NATIONAL_DIGITS) return null;

  const digits = `${country.dialCode}${national}`;

  return E164_PATTERN.test(digits) ? `+${digits}` : null;
};

export const isValidPhoneNumber = (countryCode: string, value: string): boolean =>
  normalizePhoneNumber(countryCode, value) !== null;

// Splits a stored +41791234567 back into the dropdown country and the national
// part the user typed. A dial code outside `countries` has no country to select,
// so the number is kept international and normalises on its own + prefix.
export const splitPhoneNumber = (
  value: string,
): { country: string; national: string } => {
  const cleaned = (value || '').trim().replace(PHONE_SEPARATORS, '');

  if (!/^(\+|00)/.test(cleaned)) {
    return { country: DEFAULT_PHONE_COUNTRY, national: cleaned };
  }

  const digits = cleaned.replace(/^(\+|00)/, '');
  const country = countries
    .filter((item) => digits.startsWith(item.dialCode))
    .sort((a, b) => b.dialCode.length - a.dialCode.length)[0];

  return country
    ? { country: country.value, national: digits.slice(country.dialCode.length) }
    : { country: DEFAULT_PHONE_COUNTRY, national: `+${digits}` };
};

export const MINIMUM_AGE = 18;
export const MAXIMUM_AGE = 120;

const DATE_INPUT_PATTERN = /^(\d{4})-(\d{2})-(\d{2})$/;

export const ageInYears = (birthDate: Date, today: Date = new Date()) => {
  let age = today.getFullYear() - birthDate.getFullYear();
  const monthsApart = today.getMonth() - birthDate.getMonth();
  if (
    monthsApart < 0 ||
    (monthsApart === 0 && today.getDate() < birthDate.getDate())
  ) {
    age -= 1;
  }
  return age;
};

export const parseBirthDate = (
  value: string,
  today: Date = new Date(),
): Date | null => {
  const match = DATE_INPUT_PATTERN.exec(value.trim());
  if (!match) {
    return null;
  }

  const [year, month, day] = match.slice(1).map(Number);
  const birthDate = new Date(year, month - 1, day);
  const isRealDate =
    birthDate.getFullYear() === year &&
    birthDate.getMonth() === month - 1 &&
    birthDate.getDate() === day;

  if (
    !isRealDate ||
    birthDate > today ||
    ageInYears(birthDate, today) > MAXIMUM_AGE
  ) {
    return null;
  }

  return birthDate;
};

export const birthDateInputBounds = (today: Date = new Date()) => ({
  min: new Date(
    today.getFullYear() - MAXIMUM_AGE,
    today.getMonth(),
    today.getDate(),
  ).toLocaleDateString('en-CA'),
  max: today.toLocaleDateString('en-CA'),
});

export const todayDateInputValue = (today: Date = new Date()) =>
  today.toLocaleDateString('en-CA');

export const isFutureDateInput = (
  value: string,
  today: Date = new Date(),
) => DATE_INPUT_PATTERN.test(value) && value > todayDateInputValue(today);

export const isDateStrSet = (dateStr: string) => {
  const date = new Date(dateStr);
  return date.getTime() > 0;
}